var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgArrowPrevious = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M12.3536 3.85355C12.5488 3.65829 12.5488 3.34171 12.3536 3.14645C12.1583 2.95118 11.8417 2.95118 11.6464 3.14645L7.14645 7.64645C6.95118 7.84171 6.95118 8.15829 7.14645 8.35355L11.6464 12.8536C11.8417 13.0488 12.1583 13.0488 12.3536 12.8536C12.5488 12.6583 12.5488 12.3417 12.3536 12.1464L8.20711 8L12.3536 3.85355ZM4 3.5C4 3.22386 4.22386 3 4.5 3C4.77614 3 5 3.22386 5 3.5V12.5C5 12.7761 4.77614 13 4.5 13C4.22386 13 4 12.7761 4 12.5V3.5Z",
  fill: "#262626"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrowPrevious, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/arrow-previous.0be03596.svg";
export { ForwardRef as ReactComponent };